<template>
  <div class="augmented-rounded-image">
    <div
      v-for="(item, index) in initialdata.listOfAugmentedRoundedImage"
      :key="index"
      class="augmented-rounded-image-item"
    >
      <h2 v-if="item.heading" class="augmented-title" v-html="item.heading"></h2>
      <div v-if="item.subheading" class="augmented-subheading" v-html="item.subheading"></div>
      <div v-if="item.description" class="augmented-description" v-html="item.description"></div>
      <div class="augmented-image-block" :style="{ background: item.gradientColor }">
        <img v-if="item.imageSrc != null" :src="item.imageSrc.Src" :alt="item.imageSrc.Alt" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'augmented-rounded-image',
  props: {
    initialdata: {
      type: Object,
    },
  },
};
</script>
